import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../../actions/fetch'
import { INotificationMarkAsSeen } from '../../../actions/notification/notifications'
import { fireToastError } from '../../../actions/toasts/fireToast'
import i18n from '../../../i18n'
import { markNotificationsSeen } from '../../../models/Notifications'
import { NotificationActions } from '../../../reducers/userAccount/actionNames'
import getNotifications from '../../../reducers/userAccount/selectors/notifications/getNotifications'
import { getNotificationSeen } from '../../../reducers/userAccount/selectors/notifications/getNotificationsCounts'
import { ActionNames } from '../../../utils/FetchActionsName'
import fetchActionsName from '../../../utils/FetchActionsName/fetchActionsName'

function* markAsSeen(action: INotificationMarkAsSeen) {
  try {
    const actionNames = fetchActionsName(ActionNames.MarkNotificationAsSeen)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, markNotificationsSeen),
      ),
    ])

    if (action.id === 'all') {
      const seen = yield Effects.select(getNotificationSeen)
      if (!seen || action.force) {
        const notifications = yield Effects.select(getNotifications)
        if (notifications.length !== 0) {
          yield Effects.call(service, notifications.map(not => not.id))
          yield Effects.put({ type: NotificationActions.MarkAsSeenAll })
        }
      }
    } else {
      yield Effects.call(service, action.id)
    }
  } catch (e) {
    console.error(e)
    yield Effects.put(fireToastError(i18n.t('error_server_response_2')))
  }
}

export default function*() {
  yield Effects.takeEvery(NotificationActions.MarkAsSeen, markAsSeen)
}
